module.exports = new __parcel__URL__("meeting-notes-dark.b7db3bc0.png").toString();